<template>
    <div>
        <div id="app" class="fluid menu-left">
            <form id="logoutForm" class="navbar-right"></form>
            <!-- Top navbar -->
            <!-- <asu-header/> -->
            <!-- Top navbar END -->
            <!-- Sidebar menu & content wrapper -->
            <div id="wrapper">
                <!-- Sidebar Menu -->
                <nav-menu params="route: route"></nav-menu>
                <!-- // Sidebar Menu END -->

                <div id="content">
                    <impersonation position="top"/>
                    <div style="padding: 10px 10px 5px 10px;">
                        <div style="display: none" id="errorMessage" class="alert alert-error"></div>
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
        <!-- Main container fluid END -->
        <!-- Footer -->
        <asu-footer/>
        <impersonation position="bottom"/>
        <!-- // Footer END -->
        <spinner :show="showSpinner"></spinner>
    </div>
</template>

<script>
import Vue from "vue";
import NavMenu from "./nav-menu";
import MenuTree from "./menu/menu-tree";
import MenuItem from "./menu/menu-item";
import NavTree from "./menu/nav-tree";
import NavItem from "./menu/nav-item";
import homeApi from "../api/home";
import spinner from "./spinner";
import Impersonation from "./impersonation";
// import AsuHeader from "./header";
// import AsuFooter from "./footer";

import Datepicker from "vuejs-datepicker";
import { mapActions, mapState } from "vuex";

import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
import {
  faCheck, // eslint-disable-line no-unused-vars
  faPlus, // eslint-disable-line no-unused-vars
  faTimes, // eslint-disable-line no-unused-vars
  faEdit, // eslint-disable-line no-unused-vars
  faBars, // eslint-disable-line no-unused-vars
  faUser, // eslint-disable-line no-unused-vars
  faUsers, // eslint-disable-line no-unused-vars
  faList, // eslint-disable-line no-unused-vars
  faLockOpen, // eslint-disable-line no-unused-vars
  faHome, // eslint-disable-line no-unused-vars
  faIdCard, // eslint-disable-line no-unused-vars
  faTable // eslint-disable-line no-unused-vars
} from "@fortawesome/fontawesome-free-solid";

Vue.component("nav-menu", NavMenu);
Vue.component("menu-tree", MenuTree);
Vue.component("menu-item", MenuItem);
Vue.component("nav-tree", NavTree);
Vue.component("nav-item", NavItem);
Vue.component("datepicker", Datepicker);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("spinner", spinner);

// babel-polyfill added for BootstrapVue to work with IE11
import "babel-polyfill";

import * as _ from "lodash"; // eslint-disable-line no-unused-vars

// for date formatting filters
Vue.use(require("vue-moment"));

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
require("vuelidate/lib/validators");

import DoughnutChart from "./charts/DoughnutChart.js";
Vue.component("doughnut-chart", DoughnutChart);

import AsuFooter from "./footer";

export default {
  data() {
    return {
      //xsrf: document.getElementsByName('__RequestVerificationToken')[0].value //this.$cookie.get('XSRF-TOKEN')
    };
  },
  components: {
    Impersonation,
    AsuFooter
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      requestCount: state => state.spinner.count
    }),
    logOutUri: function() {
      return process.env.VUE_APP_BASE_URI + "/home/logoff";
    },
    showSpinner: function() {
      return this.requestCount > 0;
    }
  },

  methods: {
    ...mapActions(["getUser"]),

    logOff: function() {
      homeApi
        .logOff()
        .then(function(response) {
          var redirectUrl = response.data;
          window.location.replace(redirectUrl);
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },

  beforeCreate() {
    // try to get login user
    this.$store.dispatch("getUser");
  },
  mounted() {
    var props = {
      // navTree is an array with menu items (similar to the ASUHeader.json array in 4.x header)
      navTree: [
        // {
        //   href: "/",
        //   type: "icon-home", // Home icon
        //   class: "data-class", // classes passed to  tag
        //   selected: true // set to true to  highlight menu item
        // }
      ],
      title: "MyCHS",
      parentOrg: "College of Health Solutions",
      parentOrgUrl: "https://chs.asu.edu",
      logoutLink: process.env.VUE_APP_BASE_URI + "/logoff"
    };

    componentsLibrary.initHeader(props);
  }
};
</script>

<style scoped>
#wrapper {
  position: relative;
  overflow: hidden;
  min-height: 85vh;
  width: 100%;
  /* float: left; */
  background-color: white;
  /* padding-top: 144px; */
}

#content {
  margin-left: 235px;
  background: white;
}

.impersonation-alert {
  text-align: right;
  margin: 5px;
}

a {
  cursor: pointer;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  #content {
    margin-left: initial;
    margin-top: 30px;
  }

  #wrapper {
    min-height: 70vh;
  }
}
</style>
